import * as React from "react";
import { IControlSchema } from "../../Controls";
import { IDispatcher } from "../extensions/Dispatcher";
import { ApiClient } from '../../../services/ApiClient';

interface TotalHeaderSchema extends IControlSchema{
  elements: Array<String>
}

interface Props {
  schema: TotalHeaderSchema,
  api: ApiClient;
  dispatcher: IDispatcher;
  values: Array<{
    controlid: string,
    value: any
  }>;
}

class TotalHeader extends React.Component<Props>{
  render(){
    const { values, schema: { title, elements} } = this.props;
    let total = 0;

    for(let control of values) {
      for(let el of elements){
        if((el as string) === (control.controlid as string)){
          total += parseFloat(control.value);
        }
      }
    }

    return (
      <div className="text-right">
        <h3>{title.ru} {total.toFixed(2)}</h3>
      </div>
    )
  }
}

export function createTotalHeader(schema: IControlSchema, api: ApiClient, dispatcher: IDispatcher = null, values: any){
  return <TotalHeader
      schema={schema as TotalHeaderSchema}
      api={api}
      dispatcher={dispatcher}
      values={values} 
    />
}


// WEBPACK FOOTER //
// ./src/components/controls/standart/TotalHeader.tsx